import type { ProductRoomPriceRankDailyStatusFormModel } from "../../../type";
import type { ServerModel } from "../type";

type Props = {
	serverModel: ServerModel;
};

export const convertToInputModel = ({ serverModel }: Props) => {
	const { roomPriceRankDailyStatus } = serverModel;
	const hotelID = roomPriceRankDailyStatus.hotelID;

	const inputModel: ProductRoomPriceRankDailyStatusFormModel["InputModel"] = {
		hotelID,
		statuses: roomPriceRankDailyStatus.statuses.map((rank) => {
			return {
				hotelID,
				color: rank.color ?? "#ffffff",
				date: rank.date,
				priceRankID: rank.priceRankID,
			} satisfies ProductRoomPriceRankDailyStatusFormModel["InputModel"]["statuses"][0];
		}),
	} satisfies ProductRoomPriceRankDailyStatusFormModel["InputModel"];

	return inputModel;
};
